module.exports = __webpack_public_path__ + "static/media/智慧城市白皮书.81cf3d3e.jpg";